import React from "react";
import Navbar from "./global-components/navbar-v3";
import PageHeader from "./global-components/page-header";
import GetStartedForm from "./section-components/get-started";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";

const GetStartedPage = () => {
  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Get started" />
      <GetStartedForm />
      <CallToActionV1 />
      <Footer />
    </div>
  );
};

export default GetStartedPage;
